import React, { useContext } from 'react';
import { FaUserLarge } from "react-icons/fa6";
import AuthContext from '../context/AuthProvider';
const Profile = () => {
    const {userInfo} = useContext(AuthContext)
    return (

        <div className='max-w-[600px] mx-auto'>
            <div className='flex flex-col justify-center items-center'>
                <div className='h-[150px] w-[150px] rounded-[50%] flex justify-center items-center overflow-hidden bg-[#ececec]'>
                    <FaUserLarge color='white' size={100} />
                </div>
                <div className='mt-3'>{userInfo.Number}</div>

            </div>
            <div className='mt-5 flex flex-col gap-5'>
                <input className='outline-none  border-b-2 border-[#ececec]'  type='text' value={userInfo.Name} name='firstname' />
                <input className='outline-none  border-b-2 border-[#ececec]'  type='email' value={userInfo.Email} name='email' />
                <div className='flex justify-center gap-5 items-center '>
                    <button className='border-none bg-[#978667] w-[150px] p-2 text-white'>SAVE</button>
                    <button className='border-none bg-[#978667] w-[150px] p-2 text-white'>RESET</button>
                </div>
            </div>
        </div>
    )
}

export default Profile